// AbortSignal.timeout is missing before Safari 16 and in older WebViews, where calling it
// throws and would fail every write. Aborting an already-finished fetch is a no-op, so the
// fallback timer needs no cleanup.
export function writeSignal(ms = 20_000): AbortSignal {
  if (typeof AbortSignal.timeout === 'function') return AbortSignal.timeout(ms);
  const controller = new AbortController();
  setTimeout(() => controller.abort(new DOMException('The operation timed out.', 'TimeoutError')), ms);
  return controller.signal;
}
